import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import EnhancedHeader from './EnhancedHeader';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />
      
      {/* Main content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <EnhancedHeader setSidebarOpen={setSidebarOpen} />
        <main className="flex-1 overflow-y-auto bg-gradient-subtle p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;